import React from 'react';
export function HSMSection() {
  return <section data-id="element-2903">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-2904">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center" data-id="element-2905">
          High-Speed Machining (HSM)
        </h2>
      </div>
      <div className="bg-white p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0" data-id="element-2906">
        <div className="grid md:grid-cols-3 gap-8 items-start" data-id="element-2907">
          <div className="md:col-span-2 space-y-6 text-gray-700 text-lg leading-relaxed" data-id="element-2908">
            <p data-id="element-2909">
              High speed machining is often used as an umbrella term for all
              high productivity machining methods including HEM. However, HEM
              and HSM are unique, separate machining styles. HSM encompasses a
              technique that results in higher production rates while using a
              much different approach to depth of cut and speeds and feeds.
              While certain HEM parameters are constantly changing, HSM uses
              constant values for the key parameters. A very high spindle speed
              paired with much lighter axial depths of cut results in a much
              higher allowable feed rate. This is also often referred to as feed
              milling. Depths of cut involve a very low axial and high radial
              components. The method in general is often thought of as z-axis
              slice machining, where the tool will step down a fixed amount,
              machine all it can, then step down the next fixed amount and
              continue the cycle.
            </p>

            <div className="py-4" data-id="element-2910">
              <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Mikron/Milling%202019/MILL%20S/High%20Speed%20Machining%20Productivity%202.jpg" alt="High Speed Machining Productivity" className="w-full h-auto rounded-lg shadow-sm border border-gray-200 block" data-id="element-2911" />
            </div>

            <p data-id="element-2912">
              High speed machining techniques can also be applied to contoured
              surfaces using a ball profile or corner radius tool. In these
              situations, the tool is not used in one plane at a time, and will
              follow the 3 dimensional curved surfaces of a part. This is
              extremely effective for using one tool to bring a block of
              material down to a final (or close to final) shape using high
              resultant material removal rates paired with the ability to create
              virtually any shape.
            </p>

            <p data-id="element-2913">
              High speed machining is usually associated with any spindle speed
              above 15k rpm, but it is much more than just a faster spindle. The
              whole machine must be considered when selecting a good candidate
              machine for HSM. Thermal compensation, overall machine rigidity
              and construction, positional feedback, the motion control system,
              tool retention, and many other characteristics must be looked at,
              in detail, before determining that a particular machine is
              suitable for the task.
            </p>

            <div className="bg-gray-50 p-6 rounded-lg border border-gray-200 mt-6" data-id="element-2914">
              <p className="font-bold text-[#0c79c8] text-xl mb-2" data-id="element-2915">
                For a More In Depth Look at HSM:
              </p>
              <a href="/WhatIsHighSpeedMachining.html" className="text-orange hover:underline font-bold text-lg" data-id="element-2916">
                What is High Speed Machining? →
              </a>
            </div>
          </div>

          <div className="md:col-span-1 space-y-6 bg-gray-50 p-6 rounded-lg border border-gray-200 text-center" data-id="element-2917">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Mikron/HSM/GF%20Machining%20Solutions%20Mikron%20MILL%20S%20U%205-Axis.png" alt="GF Machining Solutions Mikron MILL S U 5-Axis" className="mx-auto h-auto max-w-full block" data-id="element-2918" />
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Mikron/HSM/High%20Speed%20Machining%20Mill%20Construction.png800x800.png" alt="High Speed Machining Mill Construction" className="mx-auto h-auto max-w-full rounded-lg block" data-id="element-2919" />
            <div className="pt-4 border-t border-gray-200" data-id="element-2920">
              <p className="font-bold text-sm text-gray-500 mb-2" data-id="element-2921">MORE INFO:</p>
              <a href="59m7/gf-machining-solutions/mikron-high-speed-3-5-axis-milling/high-speed.html" target="_blank" rel="noopener noreferrer" className="text-[#0c79c8] hover:underline font-bold" data-id="element-2922">
                GF Machining Solutions Mikron MILL S U High-Speed Machining
                Centers
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}